<script>
import BaseAutocomplete from '@/components/elements/Base/BaseAutocomplete';
import CategoryService from '@/services/category-service.js';

export default {
	extends: BaseAutocomplete,
	name: 'autocomplete-auction-category',
	methods: {
		itemHasChanged(category) {
			this.$emit('update:category', category);
		},
		request() {
			return CategoryService.getAuctionCategories.bind(null, this.$route.params.auctionId);
		},
		customLabel(category) {
			return `${category.title}`;
		},
		setSelection() {
			this.getAutocomplete(this.request, '');
			this.currentSelection = this.selected;
		}
	}
}
</script>



// WEBPACK FOOTER //
// AutocompleteAuctionCategory.vue?0f34f4e4